"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var StarOff = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_StarOff_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.854.854a.5.5 0 0 0-.708-.708l-15 15a.5.5 0 0 0 .708.708l1.56-1.561c.122 1.296 1.558 2.148 2.78 1.466L8 14.194l2.806 1.565c1.372.765 3.014-.402 2.762-1.963l-.56-3.462 2.456-2.54c1.068-1.103.45-2.963-1.06-3.195l-1.989-.307L15.854.854Zm-4.316 4.315-7.99 7.99-.129.796c-.122.757.664 1.279 1.288.93l2.806-1.564a1 1 0 0 1 .974 0l2.806 1.565c.624.348 1.41-.174 1.288-.93l-.56-3.462a1 1 0 0 1 .268-.855l2.456-2.54c.512-.529.203-1.405-.494-1.512l-2.713-.418Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.7 1.09.98 2.108-.752.753-1.135-2.44a.871.871 0 0 0-1.586 0l-1.396 3a1 1 0 0 1-.754.566l-3.308.51c-.697.107-1.006.983-.494 1.513L3.71 9.64a1 1 0 0 1 .208.32l-1.034 1.034.107-.66-2.456-2.54C-.532 6.692.086 4.832 1.596 4.6l3.309-.51 1.395-3c.676-1.452 2.724-1.452 3.4 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_StarOff_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = StarOff;
exports["default"] = _default;